/**
 * pdf.js worker served as an asset (angular.json): imported, the 2 MB worker was bundled into the app and ran on
 * the main thread (pdf.js took it as its fake worker), freezing the page while a PDF was parsed.
 */
export const PDF_WORKER_SRC = 'assets/lib/pdfjs/pdf.worker.min.js';
